module.exports = new __parcel__URL__("ticket-bulb-chat.9690bd27.png").toString();